export default {
  name: 'GcPhotoGrid',
  props: {
    linkUrl: {
      type: String,
      default: 'https://www.garmin.com/en-US/company/investors/earnings/',
    },
    imageUrl: {
      type: String,
      default: 'https://static.garmincdn.com/gdc/investors/2018/investor-news__earnings--tile.jpg',
    },
    imageAltText: {
      type: String,
      default: 'image Alt text',
    },
    linkText: {
      type: String,
      default: 'link Text',
    },
  },
};
